import { CompanyDetails, MicroSiteTemplate } from "./template";

export enum ApiStatus {
  PENDING = "pending",
  COMPLETED = "completed",
  FAILED = "failed"
}

export type CreateMicroSiteResponse = {
  pollId: string;
  status: ApiStatus;
  errors: string[];
  companyName: string;
  isCompanyKnown: boolean;
};

export type PollCreateMicroSiteResponse = {
  enableDemo: boolean;
  companyDetails: CompanyDetails;
  status: ApiStatus;
  progressPercentage: number;
  pollId: string;
  errors: string[];
  template: MicroSiteTemplate;
  suggestedDomains: string[];
};

export type CustomizeMicrositePayload = {
  customPrompt: string;
  userRole: string;
  businessUnit: string;
  isSlides?: boolean;
  accountId: string;
  opportunityId: string;
};

export interface PeopleBusinessInfoRequest {
  linkedinProfileUrl?: string;
  businessEmail?: string;
  enrichRealTime: boolean;
  provideUserBusinessInfo: boolean;
  provideFullHierarchy?: boolean;
}

export interface PeopleBusinessInfoResponse {
  userBusinessInfoResponse: UseCaseUserInfoResponse;
  peopleBusinessInfo: string;
  savedToStore: boolean;
}

export interface GroupRolesMap {
  group_name: string;
  roles: string[];
}

export interface FocusGroupsMap {
  focus_name: string;
  groups: GroupRolesMap[];
}

export interface UseCaseUserInfoRequest {
  focus: string;
  group: string;
  role: string;

  generateFullHierarchy?: boolean;
}

export interface UseCaseUserInfoResponse {
  hierarchy: FocusGroupsMap[];
}

export type APIResponse<T> = {
  data: T;
  error: boolean;
  message: string;
};
